import PropTypes from 'prop-types';
import React from 'react';

import RadioGroup from './RadioGroup.jsx';

class LayoutRadioGroup extends React.PureComponent {
  static displayName = 'LayoutRadioGroup';

  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    inline: PropTypes.bool,
    keys: PropTypes.array,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    colSizes: PropTypes.array,
    onClick: PropTypes.func,
  };

  render() {
    return <div className='form-group'>
      <label>{this.props.label}</label>
      <RadioGroup {...this.props} />
      <div className='clearfix' />
    </div>;
  }
}

export default LayoutRadioGroup;
